/*
 * Public API Surface of ngx-number-input
 */

export * from './lib/ngx-number-input.component';
export * from './lib/ngx-number-input.module';
